import { ACCESS_TOKEN, ACCESS_TOKEN_EXPIRY, CONVERSATION_ID, CURRENT_SELECTION } from "../config/constants";
import { CurrentSelection } from "../interface/current-selection";

export function isLoggedIn(): boolean {
  if (!localStorage.getItem(ACCESS_TOKEN) || !localStorage.getItem(ACCESS_TOKEN_EXPIRY))
    return false;
  return !!localStorage.getItem(ACCESS_TOKEN) && +localStorage.getItem(ACCESS_TOKEN_EXPIRY)! > Date.now() / 1000
}

export function getAccessToken(): string {
  if (!localStorage.getItem(ACCESS_TOKEN))
    return '';
  return localStorage.getItem(ACCESS_TOKEN) || '';
}

export function setCurrentSelection(selected: CurrentSelection) {
  localStorage.setItem(CURRENT_SELECTION, JSON.stringify(selected))
}

export function getCurrentSelection(): CurrentSelection {
  return JSON.parse(localStorage.getItem(CURRENT_SELECTION) || "{\"id\": \"0\", \"name\": \"Error\"}")
}

export function setConversationId(id: string) {
  localStorage.setItem(CONVERSATION_ID, id)
}

export function getConversationId() {
  return localStorage.getItem(CONVERSATION_ID)
}